
  // reveal on scroll
  const io = new IntersectionObserver(es => es.forEach(e => {
    if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
  }), {threshold:.12});
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // mode toggle
  document.querySelectorAll('.mode-toggle button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('.mode-toggle button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      const mode = b.dataset.mode;
      document.querySelectorAll('.scene').forEach(s => {
        const on = s.id === 'scene-' + mode;
        s.classList.toggle('on', on);
        s.setAttribute('aria-hidden', String(!on));
      });
    });
  });

  // faq accordion
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.parentElement, a = item.querySelector('.faq-a'), open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => { i.classList.remove('open'); i.querySelector('.faq-a').style.maxHeight = null; });
      if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });


  // email capture -> Netlify Forms
  const cap = document.getElementById('capture');
  if (cap) cap.addEventListener('submit', e => {
    e.preventDefault();
    const form = e.target;
    fetch('/', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams(new FormData(form)).toString()
    }).finally(() => {
      form.style.display = 'none';
      document.getElementById('formdone').style.display = 'block';
    });
  });

  // show confirmation after Shopify signup redirect
  if (location.search.indexOf('subscribed=1') !== -1) {
    var sf = document.getElementById('shopify-capture'); if (sf) sf.style.display = 'none';
    var fd = document.getElementById('formdone'); if (fd) fd.style.display = 'block';
    var sec = document.getElementById('reserve'); if (sec) sec.scrollIntoView();
  }
